import { mountMicrophonePanel } from "./microphone-panel";

const panel = mountMicrophonePanel();

window.addEventListener("lys:microphone-panel-open", () => {
  panel.expand();
  panel.element
    .querySelector<HTMLElement>("[data-microphone-action='connect']")
    ?.focus();
});
